import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva(" rounded-full", {
  variants: {
    variant: {
      primary: "bg-orange hover:bg-orange-400 text-white",
      secondary: "bg-navy hover:bg-navy-400 text-white",
      seablue: "bg-seablue hover:bg-seablue-400 text-white",
      yellow: "bg-yellow hover:bg-yellow-400 text-white",
      green: "bg-green hover:bg-green-400 text-white",
      link: "link text-base",
      plain: "p-3",
      outline:
        "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
    },
    size: {
      large: "py-3 px-12 text-[20px] leading-[30px] font-bold",
      small: "py-2 px-[30px] font-bold",
      default: "",
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "default",
  },
});

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
  url?: string;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, url, ...props }, ref) => {
    const Comp = asChild ? Slot : url ? "a" : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        href={url}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
